import { t } from "i18next";
import React from "react";
import { slugify } from "../../helper/helperFunction";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../../routes/useCountryPrefix";
import CustomImageComponent from "../../components/CustomImageComponent";

const TopAreaSec = (props) => {
  const countryPrefix = useCountryPrefix();

  const { data } = props;

  const { i18n } = useTranslation();
  const currentLang = i18n.language === "en" ? "" : i18n.language || "";
  return (
    <>
      {data && (
        <section className="area-section">
          <div
            className="container"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <h5 className="sub-title text-center">{data?.sectionTitle}</h5>
            <h2 className="title text-center">{data?.sectionHeader}</h2>
            <div className="row">
              {data?.sectionItems?.length > 0 &&
                data.sectionItems.map((item, index) => (
                  <div className="col-md-6 col-lg-4" key={index}>
                    <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/area/${slugify(item.title)}`}>
                      <div className="flex-card">
                        <div className="img-block">
                          <CustomImageComponent
                            className={"img-fluid"}
                            src={item?.image ? `${item.image}` : ""}
                            alt={item?.title ? `${item.title}` : ""}
                          />
                        </div>
                        <div className="content-block">
                          <h4>{item.title}</h4>
                          <p>{item.description}</p>
                          <div className="position-block">
                            <h5>{item.projects}</h5>
                            <p>{t("projects")}</p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default TopAreaSec;
